// This is used for loading Javascript required by components rendered by the main neo field

// The quiz module is available in the main neo but can only be used on the hub category and hub entry types

// required by the formie neo block
import { loadModule, loadModulesWhenInView } from '@helpers/loadModule';
import { animationModules } from '@modules/animations';

export default async function init() {
  loadModulesWhenInView([
    ...animationModules,
    {
      selector: '.js-embla',
      importer: () => import('@modules/embla'),
    },
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/gtmFormSubmission'),
    },
    {
      selector: '.js-user-feedback',
      importer: () => import('@modules/userFeedback'),
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video'),
    },
    {
      selector: '.js-video-embed',
      importer: () => import('@modules/heroVideo'),
    },
    {
      selector: '.js-content-column',
      importer: () => import('@modules/scrollProgress'),
    },
    {
      selector: '.js-module-quiz',
      importer: () => import('@modules/quizModule'),
    },
    {
      selector: '.js-tooltip',
      importer: () => import('@modules/tooltip'),
    },
  ]);

  // Load modals immediately (not when in view) since dialog elements may not be detected by IntersectionObserver
  loadModule('.js-modal', () => import('@modules/modal'));
  loadModule('.js-start-course', () => import('@modules/gtmStartCourseClick'));
  loadModule('.js-admin-bar', () => import('@modules/adminBar'), true);
}
